import { useEffect, useState } from 'react';
import { PET_NAMES, STORAGE_PET_AGE_KEY, STORAGE_PET_NAME_KEY } from '../constants';

interface ShareGuideModalProps {
  open: boolean;
  onClose: () => void;
  onSaveAndShare: (petName: string, petAge: string | null) => void;
}

function getRandomPetName(): string {
  return PET_NAMES[Math.floor(Math.random() * PET_NAMES.length)];
}

export function ShareGuideModal({ open, onClose, onSaveAndShare }: ShareGuideModalProps) {
  const [petName, setPetName] = useState('');
  const [petAge, setPetAge] = useState('');

  useEffect(() => {
    if (open) {
      try {
        const savedName = localStorage.getItem(STORAGE_PET_NAME_KEY);
        const savedAge = localStorage.getItem(STORAGE_PET_AGE_KEY);
        setPetName(savedName?.trim() || getRandomPetName());
        setPetAge(savedAge || '');
      } catch {
        setPetName(getRandomPetName());
        setPetAge('');
      }
    }
  }, [open]);

  const handleSubmit = () => {
    const name = petName.trim() || getRandomPetName();
    const age = petAge.trim() || null;
    try {
      localStorage.setItem(STORAGE_PET_NAME_KEY, name);
      if (age) localStorage.setItem(STORAGE_PET_AGE_KEY, age);
    } catch {}
    onSaveAndShare(name, age);
    onClose();
  };

  if (!open) return null;

  return (
    <div
      className="overlay"
      role="dialog"
      aria-modal
      aria-labelledby="share-guide-title"
      onClick={onClose}
    >
      <div className="overlay-card" onClick={(e) => e.stopPropagation()}>
        <h3 id="share-guide-title">给 TA 起个名字吧</h3>
        <p className="hint">分享时会带上名字，更好玩～可以改我们随机起的，也可以留空。</p>
        <label htmlFor="share-pet-name">宠物名字</label>
        <input
          id="share-pet-name"
          type="text"
          value={petName}
          onChange={(e) => setPetName(e.target.value)}
          placeholder="团子"
          maxLength={20}
          autoComplete="off"
        />
        <label htmlFor="share-pet-age">年龄 <span className="optional">选填</span></label>
        <input
          id="share-pet-age"
          type="text"
          value={petAge}
          onChange={(e) => setPetAge(e.target.value)}
          placeholder="例如 2 岁"
          maxLength={10}
          autoComplete="off"
        />
        <button type="button" className="btn-save-share" onClick={handleSubmit}>
          保存并分享
        </button>
      </div>
    </div>
  );
}
